<template>
  <div class="container">
    <h1 colass='hover' v-to="'/admin/registrations'">Inscrição - <span v-if="purshaseProduct"> {{purshaseProduct._teamname }} </span></h1>

    <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
    </div>


    <div class="row" v-if="purshaseProduct">

      <div class="col-12 col-sm-8">
        <div v-to="'/admin/registrations/'"> Voltar </div>
        <purshase-product-info-edit v-if="purshaseProduct" :purshaseProduct="purshaseProduct" :key="'myregistrationinfo-'+id">
        </purshase-product-info-edit>
      </div>

      <div class="col-12 col-sm-4">
           
            <div v-if="purshaseProduct.paymentStatus != 'payed' && !purshaseProduct.payedByAdmin && purshaseProduct.canceledByAdmin!=true">
              <a  @click="markAsPayed" class='btn btn-lg btn-primary' style="color:white">
                  Marcar como pago
              </a>
            </div>

            <a  v-if="purshaseProduct.canceledByAdmin!=true" @click="markAsCanceled" class='btn btn-lg btn-danger mt-1' style="color:white">
                  Cancelar Equipe
            </a>
            
            <a  v-if="purshaseProduct.canceledByAdmin===true" @click="markAsNotCanceled" class='btn btn-lg btn-primary mt-1' style="color:white">
                  Ativar Equipe
              </a>
            <!-- <pre>
              {{purshaseProduct}}
            </pre> -->

            <div v-if="purshaseProduct.payedByAdmin == true" class="alert alert-success">
                <h4> Equipe Inscrita com sucesso! </h4>
            </div>

            <hr>

            <order-paymentstatus class='mt3' v-if="!purshaseProduct.payedByAdmin" :allinfos="false" :orderid="purshaseProduct.orderId" />
      </div>
    </div>
    <!-- {{ purshaseProduct }} -->
  </div>
</template>


<script>
  export default {
    data(){
      return {error:false}
    },

    created:async function () {
      let res = await this.$store.dispatch('PurchaseStore/loadRegistrationsById',this.id)
          if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
    },

    watch:{
      id:async function(){
          this.error = false;
           let res = await this.$store.dispatch('PurchaseStore/loadRegistrationsById',this.id)
          if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
      }
    },

    computed: {
      id: function () {
        return parseInt(this.$route.params.id)
      },

      purshaseProduct: function () {
        return this.$store.getters['PurchaseStore/purshaseProductById'](this.id)
      },

    },

    methods:{
      markAsPayed:function(){
          this.$store.dispatch( 'PurchaseStore/markAsPayed', this.id )
      },
      markAsCanceled:function(){
          this.$store.dispatch( 'PurchaseStore/markAsCanceled', this.id )
      },
      markAsNotCanceled:function(){
          this.$store.dispatch( 'PurchaseStore/markAsNotCanceled', this.id )
      }
    }


  }
</script>

<style>

</style>
